import React, { useEffect, useState, useCallback } from "react";
import { useOutletContext } from "react-router-dom";
import { Header } from "../components/Sidebar";
import api, { apiErr } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";
import { Plus, Users2 } from "lucide-react";
import { toast } from "sonner";
import { SearchBox, matchQ } from "../components/SearchBox";

const input = "w-full rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:border-[#3B82F6] focus:ring-2 focus:ring-blue-100";

export default function Clientes() {
  const { setMobileOpen } = useOutletContext();
  const [clientes, setClientes] = useState([]);
  const [q, setQ] = useState("");
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ nombre: "", whatsapp: "", ciudad: "", email: "" });

  const load = useCallback(() => { api.get("/clientes").then(({ data }) => setClientes(data)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/clientes", form); toast.success("Cliente creado"); setShow(false); setForm({ nombre: "", whatsapp: "", ciudad: "", email: "" }); load(); }
    catch (e2) { toast.error(apiErr(e2)); }
  };

  return (
    <>
      <Header title="Clientes" subtitle="Remitentes y cuentas comerciales" onMenu={() => setMobileOpen(true)}
        action={<button onClick={() => setShow(true)} data-testid="new-cliente-btn" className="flex items-center gap-2 text-sm font-semibold bg-[#0A1F44] hover:bg-[#132D5C] text-white rounded-lg px-3.5 py-2"><Plus className="h-4 w-4" /> Nuevo cliente</button>} />
      <main className="p-4 sm:p-6 lg:p-8">
        <SearchBox value={q} onChange={setQ} placeholder="Buscar cliente por nombre, WhatsApp, ciudad o email…" testid="clientes-search" />
        <div className="bg-white rounded-xl border border-[#E2E8F0] shadow-sm overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-[#64748B] text-xs uppercase">
              <tr><th className="text-left font-semibold px-4 py-3">Nombre</th><th className="text-left font-semibold px-4 py-3">WhatsApp</th><th className="text-left font-semibold px-4 py-3 hidden sm:table-cell">Ciudad</th><th className="text-left font-semibold px-4 py-3 hidden md:table-cell">Email</th></tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {clientes.filter(matchQ(q)).map((c) => (
                <tr key={c.id} className="hover:bg-slate-50/60">
                  <td className="px-4 py-3 font-semibold text-[#0A1F44]">{c.nombre}</td>
                  <td className="px-4 py-3 text-[#64748B]">{c.whatsapp}</td>
                  <td className="px-4 py-3 hidden sm:table-cell text-[#64748B]">{c.ciudad || "—"}</td>
                  <td className="px-4 py-3 hidden md:table-cell text-[#64748B]">{c.email || "—"}</td>
                </tr>
              ))}
              {clientes.length === 0 && <tr><td colSpan={4} className="px-4 py-12 text-center text-[#64748B]"><Users2 className="h-8 w-8 mx-auto mb-2 text-slate-300" />No hay clientes cargados.</td></tr>}
            </tbody>
          </table>
        </div>
      </main>
      <Dialog open={show} onOpenChange={setShow}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader><DialogTitle className="font-display">Nuevo cliente</DialogTitle></DialogHeader>
          <form onSubmit={submit} className="space-y-3">
            <input className={input} placeholder="Nombre / razón social" value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} required data-testid="cliente-nombre-input" />
            <input className={input} placeholder="WhatsApp" value={form.whatsapp} onChange={(e) => setForm({ ...form, whatsapp: e.target.value })} required data-testid="cliente-whatsapp-input" />
            <input className={input} placeholder="Ciudad" value={form.ciudad} onChange={(e) => setForm({ ...form, ciudad: e.target.value })} />
            <input className={input} type="email" placeholder="Email (opcional)" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            <button className="w-full rounded-lg bg-[#0A1F44] text-white font-semibold py-2.5 text-sm" data-testid="cliente-submit-btn">Guardar</button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
